import Modal from '@components/v2/ui/Modal/Modal';
import { useModalState } from '../../../../hooks/useModalState';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import OfflineConfirmDeleteProductsModal from './components/OfflineConfirmDeleteProductsModal/OfflineConfirmDeleteProductsModal';
import OfflineModalContent from './components/OfflineModalContent/OfflineModalContent';
import OfflineModalProps from './offlineModal.types';

const OfflineModal = ({
  open,
  isOpen,
  onClose,
  updateData,
  downloadData,
  lastSyncedAt,
  hasSyncedData,
  removeOfflineData,
}: OfflineModalProps) => {
  const { translate } = useTranslation();

  const {
    isOpen: isOpenOfflineConfirmDeleteDataModal,
    openModal: openOfflineConfirmDeleteDataModal,
    closeModal: closeOfflineConfirmDeleteDataModal,
  } = useModalState();

  const openConfirmDeleteDataModal = () => {
    openOfflineConfirmDeleteDataModal();
    onClose();
  };

  const handleCloseOfflineConfirmDeleteDataModal = () => {
    open();
    closeOfflineConfirmDeleteDataModal();
  };

  const handleRemoveOfflineData = () => {
    closeOfflineConfirmDeleteDataModal();

    removeOfflineData();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        size="standard"
        header={{ title: translate(LangEnum.GLOBAL_OFFLINE_MODE) }}
        onClose={onClose}
      >
        <OfflineModalContent
          updateData={updateData}
          downloadData={downloadData}
          lastSyncedAt={lastSyncedAt}
          hasSyncedData={hasSyncedData}
          removeOfflineData={openConfirmDeleteDataModal}
        />
      </Modal>

      <OfflineConfirmDeleteProductsModal
        removeOfflineData={handleRemoveOfflineData}
        isOpen={isOpenOfflineConfirmDeleteDataModal}
        onClose={handleCloseOfflineConfirmDeleteDataModal}
      />
    </>
  );
};

export default OfflineModal;
